import { render, staticRenderFns } from "./LogisticsCalendar.vue?vue&type=template&id=6ecfeedc&scoped=true"
import script from "./LogisticsCalendar.vue?vue&type=script&lang=js"
export * from "./LogisticsCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecfeedc",
  null
  
)

export default component.exports